import React, { useEffect } from "react";
import AuthLayout from "../AuthLayout";
import styles from "./verifycode.module.scss";
import Button from "../../Shared/Button";
import OtpInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { verifyCode } from "../../../helpers";

const VerifyCodeSchema = yup.object().shape({
  otp: yup.string().required("Required"),
});

const VerifyCode = () => {
  const location = useLocation();
  const email = location?.state?.email || "";
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: VerifyCodeSchema,
    onSubmit: (values) => {
      const data = {
        email,
        otp: values.otp,
      };
      handleSubmitVerifyCode(data);
    },
  });

  const handleSubmitVerifyCode = async (values) => {
    try {
      const response = await verifyCode(values);
      toast.success("Code verified. Please reset your password.");
      const accessToken = response?.access_token || "";
      navigate("/reset-password", {
        state: {
          isVerified: true,
          accessToken,
          email,
        },
      });
      formik.setSubmitting(false);
    } catch (error) {
      const errorMessage = error?.response?.data?.message || null;
      toast.error(
        errorMessage ? errorMessage : "Something went wrong. Please try again."
      );
      formik.setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!email) navigate("/");
  }, [email]);
  return (
    <AuthLayout>
      <>
        <div className={styles["verify_code_container"]}>
          <div className={styles["verify_code_text"]}>Enter Secret Code</div>
          <div className={styles["label_container"]}>
            Enter secret code we sent you on “{email || ""}”
          </div>

          <div>
            <OtpInput
              value={formik.values.otp}
              onChange={(value) => {
                formik.setFieldValue("otp", value);
              }}
              numInputs={4}
              renderInput={(props) => <input {...props} />}
              containerStyle={styles["otp_container"]}
              inputStyle={styles["otp_input"]}
              skipDefaultStyles
            />
          </div>
          <div className={styles["otp_error"]}>
            {formik.errors.otp && formik.touched.otp && formik.errors.otp}
          </div>

          <div className={styles["submit_button_container"]}>
            <Button
              type="submit"
              className={styles["submit_button"]}
              onClick={() => {
                formik.handleSubmit();
              }}
              disabled={formik.isSubmitting}
              text="Next"
            />
          </div>
        </div>
      </>
    </AuthLayout>
  );
};

export default VerifyCode;
